<template>
  <div class="topdiv bg-m">
    <div class="htmldiv">
      <router-link to="/">
        <img src="../../assets/images/index_01_01.png" />
      </router-link>
      <div class="rdiv fr tright">
        <div class="searchdiv mt20 prelative">
          <div class="pinput br5 prelative ofhidden dinline-block bgw tleft vbottom">
            <input class="input dinline-block" name="" placeholder="请输入关键字搜索" v-model="keyword">
            <a class="zbtn pabsolute trans3" href="javascript:void(0);" @click="search"></a>
          </div>
          <div class="pzbtn vbottom dinline-block prelative ml25" @mouseenter="toggle(1)"  @mouseleave="cancelTxt(1)">
              <span class="zbtn zbtn-blue" >登录</span>
              <div v-if="is_login" class="ptxt pabsolute" >
                  <a class="dblock" href="/lms/web" target="_blank">学历教育</a>
                  <a class="dblock" href="/lms/web" target="_blank">技能培训考证</a>
              </div>
          </div>
          <div class="pzbtn vbottom dinline-block prelative ml15" @mouseenter="toggle(0)" @mouseleave="cancelTxt(0)">
              <span class="zbtn zbtn-blue">查询</span>
              <div v-if="is_link" class="ptxt pabsolute" >
                  <a class="dblock" href="https://cr.zjzs.net/" target="_blank">成考录取</a>
                  <a class="dblock" href="javascript:;">学分银行</a>
              </div>
          </div>
        </div>

        <div class="nnav fs18 mt10 twhite">
          <router-link to='/' class="am mr15 dinline-block twhite">首页</router-link>
          <router-link to='/about' class="am mr15 dinline-block twhite">学院介绍</router-link>
          <div class="hav am mr15 fs18 dinline-block tcenter cpointer prelative">
            学历教育<span class="jt"></span>
            <div class="snav tleft bgw prelative fs16 tc3">
              <router-link to="/aedu/index" class="dblock tcenter">专科函授</router-link>
              <span  class="snav-sub prelative dblock tcenter">

                专升本
                  <div class="ssnav dnone">
                    <router-link to='/cedu/index' class="dblock tcenter">自考</router-link>
                <!--待定-->
                <router-link to="/hedu/index" class="dblock tcenter">函授</router-link>

                  </div>
              </span>
              
              <!-- <router-link to="/dedu/index" class="dblock tcenter">远程教育</router-link> -->
            </div>
          </div>
          <router-link to="/train/index"  class="am mr15 dinline-block twhite">社会培训</router-link>
          <router-link to='/zedu/index' class="am mr15 dinline-block twhite">普通专升本</router-link>
         <!-- <router-link to='/'><a href="javascript:;" class="mr25 dinline-block twhite">首页</a></router-link>
          <router-link to='/about'><a href="javascript:;" class="mr25 dinline-block twhite">学院简介</a></router-link>
          <router-link to="/aedu/index" class="mr25 dinline-block twhite">学历教育</router-link>
          <router-link to="/cedu/index" class="mr25 dinline-block twhite">专升本自考</router-link>
          <router-link to="/dedu/index" class="mr25 dinline-block twhite">远程教育</router-link>
          <router-link to="/" class="mr25 dinline-block twhite">专技继续教育</router-link>
          <router-link to="/train/index" class="dinline-block twhite">培训与技能考证</router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  data () {
    return {
      keyword : '',
      is_login: 0,
      is_link: 0,
    }
  },
  methods:{
    search:function () {
      this.$router.push({path:'/search',query:{keyword:this.keyword}})

    },
    toggle(is_login){
      this.is_login = is_login
      this.is_link = !is_login
    },
    cancelTxt (type) {
      if(type == 1)
        this.is_login = 0
      else
        this.is_link = 0
    }
  }
}
</script>

<style scoped>
  .bg-m a:hover{text-decoration: underline;}
  .pinput{width: 220px;height: 36px;background: #385d8c;}
  .pinput input{width: 182px;height: 36px;border: none;outline: none;}
  .pinput input:focus{box-shadow: none;}
  .pinput .zbtn{right: 0;top: 0;width: 36px;height: 36px;background:  url(../../assets/images/cn1.png) no-repeat -22px -11px;}
  .pinput .zbtn:hover{background-position: -23px -13px;}

  .nnav{margin-top: 14px;height: 50px;}
  .nnav .jt{display: inline-block;margin-left: 15px;content: '';width: 12px;height: 12px;border-left: 1px solid #c8c8c8;border-bottom: 1px solid #c8c8c8; -webkit-transform:rotate( -45deg) translateY(-3px);transition: transform .2s;}
  .nnav .hav:hover .jt,.nnav .jt.xia{border-color: #063674;-webkit-transform: translateY(4px) rotate(135deg);}
  .nnav .am{position: relative;padding: 0 25px;line-height: 50px;}
  .nnav .am:last-child{margin-right: 0;}
  .nnav .hav:hover{background: #fff;border-top-left-radius: 5px;border-top-right-radius: 5px;color: #063674;}
  .nnav .hav:hover .snav{height: auto;transform: rotate3d(0,0,0,0);z-index: 1000;}
  .nnav .hav::after,.nnav .snav{transition: all .3s ease-in-out;}
  .nnav .snav{/*overflow: hidden;*/position: absolute;left: 0;padding: 0;right: 0;width: auto;height: 50px;background: #fff;border-bottom-left-radius: 4px;border-bottom-right-radius: 4px;transform: rotate3d(1,0,0,
  90deg);transform-origin: center top;}
  .nnav .snav a{padding: 0;line-height: 45px;}
  .nnav .snav a:hover,
  .nnav .snav .snav-sub:hover{background: #F3F3F3;font-weight: bold;color: #063674;text-decoration: none;}
  .nnav .snav .snav-sub:hover .ssnav{display: block;}
  .nnav .snav .snav-sub .ssnav{position: absolute;left: 100%;top: 0;width: 100px;box-shadow: 0 0 15px #ccc;line-height: 50px;font-size: 15px;font-weight: normal;background: #fff;}
  .zbtn-blue{padding: 8px 15px;line-height: 1;background: #64bed0;border-radius: 8px;font-size: 16px;}
  .zbtn-blue:hover{text-decoration: underline;}
  .pzbtn{padding-bottom: 3px;}
  .ptxt{z-index: 999;top: 100%;left: 50%;transform: translateX(-50%);padding: 12px 20px;box-shadow: 0 0 2px #ccc;line-height: 1.8;background: #fff;border-radius: 8px;color: #333;text-align: left;word-break: keep-all;}
  .ptxt a:hover{font-weight: bold;color: #64bed0;}
</style>



// WEBPACK FOOTER //
// src/components/index/top.vue